<template>
    <transition name="vf-fade">
        <div v-if="visible" class="vf-toast-mask" :style="{pointerEvents: mask ? 'auto' : 'none'}">
            <div class="vf-toast-wrap">
                <div class="vf-toast-box">
                    <div class="vf-toast-icon" v-if="type === 'loading'">
                        <i class="vf-spinner"></i>
                    </div>
                    <div class="vf-toast-icon" v-else-if="type === 'success'">
                        <span class="el-icon-check"></span>
                    </div>
                    <div class="vf-toast-icon" v-else-if="type === 'warning'">
                        <span class="el-icon-warning-outline"></span>
                    </div>
                    <div class="vf-toast-icon" v-else-if="type === 'error' || type === 'fail'">
                        <span class="el-icon-close"></span>
                    </div>
                    <div class="vf-toast-icon" v-else-if="type === 'custom' && customIcon" v-html="customIcon"></div>
                    <div class="vf-toast-text" v-html="message"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'VfToast',
    data() {
        return {
            visible: false,
            message: '',
            type: 'none', // 'success' | 'error' | 'warning' | 'fail' | 'loading' | 'none' | 'custom'
            mask: false,
            customIcon: null,
        }
    },
    methods: {
        show(opts = {}) {
            this.message = opts.title || opts.message || '';
            this.type = opts.icon || "none";
            this.mask = !!opts.mask;
            this.customIcon = opts.customIcon || null;
            this.visible = true;
        },
        hide() {
            this.visible = false;
        }
    }
}
</script>

<style scoped>
.vf-fade-enter-active,
.vf-fade-leave-active {
    transition: opacity 0.18s ease;
}
.vf-fade-enter,
.vf-fade-leave-to {
    opacity: 0;
}
.vf-toast-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
}
.vf-toast-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}
.vf-toast-box {
    pointer-events: auto;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 12px 18px;
    border-radius: 8px;
    max-width: 80%;
    text-align: center;
    display: inline-flex;
    align-items: center;
    flex-direction: column;
}
.vf-toast-icon {
    margin-bottom: 6px;
    color: #fff;
    font-size: 36px;
}
.vf-icon {
    display: block;
}
.vf-toast-text {
    font-size: 14px;
    line-height: 1.2;
    color: #fff;
}
.vf-spinner {
    width: 30px;
    height: 30px;
    display: inline-block;
    border-radius: 50%;
    box-sizing: border-box;
    border: 3px solid rgba(255, 255, 255, 0.25);
    border-top-color: #fff;
    animation: vf-rotate 1s linear infinite;
}
@keyframes vf-rotate {
    100% {
        transform: rotate(360deg);
    }
}
</style>
